import { IsBoolean } from 'class-validator';

export class PosValidateUniqueManagerPinResponseDto {
  /**
   * Flag indicating unique Pos Access Pin in cost center
   */
  @IsBoolean() public isUnique: boolean;

  constructor(isUnique: boolean) {
    this.isUnique = isUnique;
  }
}
